import React from 'react';
import {GlassCard} from "../ui/Card";
import {RocketIcon, SearchIcon, ToolsIcon} from "../ui/Icons";

const WorkFormatsSection: React.FC = () => {
    const formats = [
        {
            icon: <RocketIcon />,
            title: "Запуск идеи",
            className: "col-span-2",
            desc: "Есть идея, нужен MVP, важно быстро проверить гипотезу.",
            result: "понятный продукт + чёткий план развития",
            delay: ""
        },
        {
            icon: <ToolsIcon />,
            title: "Под ключ",
            className: "col-span-1",
            desc: (
                <>
                    Нужен <span className="accent-highlight">сайт</span>, <span className="accent-highlight">мобильное приложение</span> или <span className="accent-highlight">бот</span> с гарантией запуска.
                </>
            ),
            result: "готовый работающий инструмент для бизнеса",
            delay: "delay-1"
        },
        {
            icon: <SearchIcon />,
            title: "Аудит и порядок",
            className: "col-span-1",
            desc: "Есть проект, но код сложный, а работает медленно.",
            result: "список проблем и план оптимизации",
            delay: "delay-2"
        }
    ];

    return (
        <section id="formats" className="section">
            <div className="container">
                <h2 className="section-title text-center">Форматы <strong>работы</strong></h2>
                <div className="formats-grid">
                    {formats.map((item, index) => (
                        <GlassCard key={index} className={item.className}>
                            <div className="format-header section-title">
                                <div className="format-icon-wrapper">
                                    {item.icon}
                                </div>
                                <h3 className="accent"><strong>{item.title}</strong></h3>
                            </div>
                            <div className="format-body">
                                <p className="format-desc">{item.desc}</p>
                                <div className="format-result">
                                    <span className="section-title"><strong>Результат:</strong></span> {item.result}
                                </div>
                            </div>
                        </GlassCard>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WorkFormatsSection;
